import { render, staticRenderFns } from "./ProjectBrowser.vue?vue&type=template&id=431bc51b&scoped=true&"
import script from "./ProjectBrowser.vue?vue&type=script&lang=ts&"
export * from "./ProjectBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectBrowser.vue?vue&type=style&index=0&id=431bc51b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431bc51b",
  null
  
)

export default component.exports